import { ButtonHTMLAttributes } from 'react';

/**
 * Botón de acción que envuelve un ícono. Reemplazo nativo del fork para el
 * `IconButton` de @mui/material usado en las vistas de programas no
 * estructurados, manteniendo la misma API (aria-label, title, onClick,
 * disabled, onMouseDown, children).
 */
export default function IconButton({
  children,
  className,
  type = 'button',
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type={type}
      className={`btn p-1 d-inline-flex align-items-center justify-content-center${
        className ? ` ${className}` : ''
      }`}
      {...rest}
    >
      {children}
    </button>
  );
}
